import { ImageStatus } from '../types';

export class ImageStatusStore {
	private _images: Record<string, ImageStatus>;

	constructor() {
		this._images = {};
	}

	set(src: string, status: ImageStatus) {
		this.images[src] = status;
	}

	get(src: string) {
		return this.images[src];
	}

	get images() {
		return this._images;
	}
}
